import refferedIcon from "../assets/icons/Refferedpageicon.svg";
import devicesIcon from "../assets/icons/devices.svg";

export const menuConfig = [
  {
    label: "MAIN MENU",
    label2: "MENU",
    data: [
      {
        title: "Dashboard",
        icon: "ic:round-dashboard",
        path: "/dashboard",
        role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"],
        migrationAllowed: true,
      },
      {
        title: "Test Collections",
        icon: "solar:file-bold",
        path: "/test-collections",
        role: ["b2b", "b2b-admin", "b2b-member"],
        permission: "canViewRequests",
      },
      {
        title: "ECG Reports",
        icon: "material-symbols:ecg",
        path: "/ecg-reports",
        role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor"],
        permission: "canViewReports",
        migrationAllowed: true,
      },
      {
        title: "Patients",
        icon: "mdi:account-group",
        path: "/patients",
        role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"],
      },
      {
        title: "Interpretation",
        icon: "icon-park-solid:table-report",
        path: "/interpretation",
        role: ["b2b", "b2b-admin", "b2b-doctor"],
        permission: "canInterpreteReport",
      },
      {
        // canViewCases is a b2b-doctor-only permission (see UserPermissions.json)
        // b2b/b2b-admin are never granted it, so it can't gate their visibility here.
        title: "Referred Cases",
        icon: refferedIcon,
        path: "/cases",
        role: ["b2b", "b2b-admin"],
      },
      {
        title: "Referred Cases",
        icon: refferedIcon,
        path: "/cases",
        role: ["b2b-doctor"],
        permission: "canViewCases",
      },
      {
        title: "Screening",
        icon: "mdi:clipboard-pulse",
        path: "/screening",
        role: ["b2b", "b2b-admin", "b2b-doctor"]
      },
      {
        title: "Devices",
        icon: devicesIcon,
        path: "/devices",
        role: ["b2b"]
      },
    ],
  },
  {
    label: "INSIGHTS",
    label2: "INSIGHTS",
    data: [
      {
        title: "Analytics",
        icon: "mdi:chart-box-outline",
        path: "/analytics",
        role: ["b2b"]
      },
    ],
  },
  {
    label: "OTHER",
    label2: "OTHER",
    data: [
      {
        title: "Settings",
        icon: "weui:setting-filled",
        path: "/settings",
        role: ["b2b", "b2b-admin", "b2b-member"],
        migrationAllowed: true,
      },
       {
        title: "Facilities",
        icon: "mdi:ambulance",
        path: "/facilities",
        role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"]
      },
      {
        title: "Manage Facilities",
        icon: "mdi:hospital-box-outline",
        path: "/manage-facilities",
        role: ["b2b", "b2b-admin"]
      },
      {
        title: "Bulk Import",
        icon: "mdi:file-upload-outline",
        path: "/import-onboarding",
        role: ["b2b"],
      },
      {
        title: "Help Centre",
        icon: "material-symbols:help",
        path: "/help-center",
        role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"],
        migrationAllowed: true,
      },
    ],
  },
];
